import React, { useState } from "react";
import { PMDialog } from "../../../utils/PMDialog";
import { PMField } from "../../../utils/PMField";
import { Form, Formik } from "formik";
import { toast } from "react-hot-toast";
import { dispatchWithToast } from "../../../Utils";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createProjectFolderAsync } from "../../../../slices/project/folder";
import { FolderIcon } from "@heroicons/react/24/outline";

export const FolderCreateDialog = ({ open, onClose, project, onFolderCreated }) => {
  const dispatch = useDispatch();

  const handleSubmit = (values, helpers) => {
    try {
      dispatchWithToast(
        dispatch(createProjectFolderAsync(values)),
        (newFolder) => {
          if (onFolderCreated) {
            onFolderCreated(newFolder);
          }
          onClose();
        },
        () => {
          helpers.setSubmitting(false);
        }
      );

      helpers.setStatus({ success: true });
      helpers.setSubmitting(false);
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong...");
      console.error(err);
      helpers.setStatus({ success: false });
      helpers.setErrors({ submit: err.message });
      helpers.setSubmitting(false);
    }
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title="Opprett ny mappe"
    >
      <div className="mt-4">
        <Formik
          initialValues={{
            id: null,
            project_id: project?.id,
            title: "",
            description: "",
            submit: null,
          }}
          validationSchema={Yup.object({
            project_id: Yup.string().required("Project ID is required"),
            title: Yup.string().required("Tittel er påkrevd"),
          })}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form>
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-6 sm:col-span-6">
                  <PMField
                    name="title"
                    type="text"
                    label="Tittel"
                    {...formik}
                  />
                </div>
                <div className="col-span-6 sm:col-span-6">
                  <PMField
                    name="description"
                    type="text"
                    label="Beskrivelse"
                    multiline
                    {...formik}
                  />
                </div>
              </div>

              <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                <button
                  type="button"
                  className="inline-flex justify-center w-20 rounded-md border border-transparent bg-gray-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                  onClick={onClose}
                >
                  Avbryt
                </button>

                <button
                  type="submit"
                  disabled={formik.isSubmitting}
                  className="inline-flex align-right justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm disabled:bg-gray-400"
                >
                  {formik.isSubmitting ? "Oppretter..." : "Opprett mappe"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </PMDialog>
  );
};
